import {calcUserScore} from 'helpers/common-helper';
import {getDefaultExposure} from 'helpers/player-helper';
import BasePlayer from 'services/sports/cfb/player/player';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';
import Action from 'actions';
import Const from 'constants';

export default class Player extends BasePlayer {
    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnScenario('externalId');
        builder.addTaskOnProperty('gameInfo');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const {userPointsType = 'adminPoints'} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer[userPointsType]);

        return {
            ...expandedPlayer,
            teamTotal: parseFloat(expandedPlayer.teamTotal),
            userPoints: parseFloat(userPoints),
            userScore: calcUserScore(userPoints, expandedPlayer.salary, this.userScoreMultiplier),
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
            },
            isFitForLineup(substitutablePlayer) {
                const substitutePlayerLineupPositions = this.positionName.split('/');
                if (substitutablePlayer.positionInLineup === Const.POSITION_CFB_NAMES.draftkings.SUPERFLEX) {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['QB', 'RB', 'WR']));
                } else if (substitutablePlayer.positionInLineup === Const.POSITION_FLEX) {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['RB', 'WR']));
                }

                return substitutePlayerLineupPositions.some(
                    (position) => substitutablePlayer.positionInLineup === position,
                );
            },
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
        };
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        if (data.hasOwnProperty('teamNameStacking')) {
            dispatch(Action.setTeamNameStackingFromStorage(data.teamNameStacking));
        }

        if (data.hasOwnProperty('flexMaxExposurePositions')) {
            dispatch(Action.set('FlexMaxExposurePositionsFromStorage', data.flexMaxExposurePositions));
        }

        if (data.hasOwnProperty('superFlexMaxExposurePositions')) {
            dispatch(Action.set('SuperFlexMaxExposurePositionsFromStorage', data.superFlexMaxExposurePositions));
        }
    }
}
